<template>
    <div class="mt-4 p-0 mr-0 ml-0 mb-0 d-print-none">
        <v-row dense class="d-print-none">
             <v-col cols="12" sm="12" md="3">
                <v-btn
                    @click.prevent="backFilter()" 
                    :class="$css_button"
                    outlined
                    :block="$vuetify.breakpoint.smAndDown"
                >
                    <v-icon left>
                        mdi-chevron-left
                    </v-icon>
                    Voltar para pesquisa
                </v-btn>
            </v-col>

            <v-col cols="12" sm="12" md="9" :class="$vuetify.breakpoint.smAndDown ? 'text-center' : 'text-right'">
                <order-new-component 
                    :object="items_order"
                    @callLoadItems="changeOrder"
                />
            </v-col>
        </v-row>
        <v-row v-if="proposals.meta" class="mt-2 mb-2">    
            <v-col cols="12" sm="12" md="6">
                <div class="text-h6">Total: {{ proposals.meta.total }} -  Página {{ proposals.meta.current_page }} de {{ proposals.meta.last_page }}</div>
            </v-col>
            <v-col cols="12" sm="12" md="6">
                <pagination-component 
                    :meta="proposals.meta"
                    @page-changed="changePage"
                />
            </v-col>    
        </v-row>
        <v-row dense class="d-print-none">
            <v-col>
                <proposal-report v-if="proposals.data" :items="proposals.data"></proposal-report>
            </v-col>
        </v-row>

        <v-row v-if="proposals.meta" class="mt-2 mb-2">    
            <v-col cols="12" sm="6" md="6">
                <div class="text-h6">Total: {{ proposals.meta.total }} -  Página {{ proposals.meta.current_page }} de {{ proposals.meta.last_page }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <pagination-component 
                    :meta="proposals.meta"
                    @page-changed="changePage"
                />
            </v-col> 
        </v-row>
    </div>
</template>

<script>
import PaginationComponent from '@/components/pagination/PaginationComponent.vue';
import OrderNewComponent from '@/components/order/OrderNewComponent.vue';
import ProposalReport from './ProposalReport.vue';

export default {
    components: {
        ProposalReport,
        PaginationComponent,
        OrderNewComponent
    },

    data () {
        return {
            proposals: {},

            items_order: {
                current_order: { 
                    value: 'proposals.codigo', 
                    description: 'Codigo',
                    sense: 'desc',
                    sense_description: 'maior -> menor',
                    params: ''
                },
                sense: [
                    { value: 'asc', description: 'menor -> maior' },
                    { value: 'desc', description: 'maior -> menor' },
                ],
                items:[
                    {
                        value: 'proposals.status', 
                        description: 'Status'
                    },
                    {
                        value: 'proposals.created_at', 
                        description: 'Data de cadastro'
                    },    
                ] 
            },
        }
    },
    
    mounted() {
        const current_order = this.items_order.current_order;
        const sense = current_order.sense;

        const filters = { ...this.$route.query, page: this.currentPage, order: current_order.value, sense: sense}; // Cópia direta dos parâmetros
        this.loadPromisseProposals(filters);
    },

    methods: {
        async loadPromisseProposals(params = null) {
            this.$store.dispatch('loadPromisseProposals', params) 
                        .then(response => {
                            this.proposals = response;
                            this.$nextTick(() => {
                                window.scrollTo(0, 0);
                            });
                        })
        },

        backFilter(){
            const filters = { ...this.$route.query}; // Cópia direta dos parâmetros
            
            this.$router.push({
                name: 'admin.proposals.filter',
                query: filters
            });
            
        },

        changePage(page) {
            const filters = { 
                ...this.$route.query, 
                page: page, 
                order: this.items_order.current_order.value, 
                sense: this.items_order.current_order.sense
            };
            this.loadPromisseProposals(filters);
        },

        changeOrder(params){
            this.items_order.current_order.value = params.order;
            const items = this.items_order.items.filter( model => model.value == params.order);
            if(items && items.length > 0){
                this.items_order.current_order.description = items[0].description;
            }

            this.items_order.current_order.sense = params.sense;
            const sense_items = this.items_order.sense.filter( model => model.value == params.sense);
            if(sense_items && sense_items.length > 0){
                this.items_order.current_order.sense_description = sense_items[0].description;
            }

            const filters = { ...this.$route.query, page: 1, order: params.order, sense: params.sense }; // Cópia direta dos parâmetros
            this.loadPromisseProposals(filters);
        }
    }
}

</script>
